module.exports = __webpack_public_path__ + "img/partner5.5392a976.gif";